var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M45.59,61H18.41A6.4,6.4,0,0,1,12,54.61V14.2a2,2,0,0,1,2-2H50a2,2,0,0,1,2,2V54.61A6.4,6.4,0,0,1,45.59,61ZM16,16.2V54.61A2.4,2.4,0,0,0,18.41,57H45.59A2.4,2.4,0,0,0,48,54.61V16.2Z",
    className: "color222 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M54.16,16.2H9.84a2,2,0,0,1,0-4H54.16a2,2,0,0,1,0,4Z",
    className: "color222 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M24.33,16.2a2,2,0,0,1-2-2V8.29A5.3,5.3,0,0,1,27.62,3H32a2,2,0,0,1,0,4H27.62a1.29,1.29,0,0,0-1.29,1.29V14.2A2,2,0,0,1,24.33,16.2Z",
    className: "color222 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M39.67 16.2a2 2 0 0 1-2-2V8.29A1.29 1.29 0 0 0 36.38 7H32a2 2 0 0 1 0-4h4.38a5.3 5.3 0 0 1 5.29 5.29V14.2A2 2 0 0 1 39.67 16.2zM38.28 44.88a2 2 0 0 1-1.41-.58L24.3 31.73a2 2 0 1 1 2.83-2.83L39.7 41.47a2 2 0 0 1-1.42 3.41z",
    className: "color222 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M25.72,44.88a2,2,0,0,1-1.42-3.41L36.87,28.9a2,2,0,0,1,2.83,2.83L27.13,44.3A2,2,0,0,1,25.72,44.88Z",
    className: "color222 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteorder);
export default __webpack_public_path__ + "static/media/deleteorder.38651efd6c6439715c9adc74331c651d.svg";
export { ForwardRef as ReactComponent };